module.exports = __webpack_public_path__ + "img/Union.99f90102.svg";